export default {
  logisticscompany: {
    LogisticsCompanyName: 'Logistics Company Name',
    Mobile: 'Mobile',
    Address: 'Address',
    LinkMan: 'Link Man',
    Website: 'Website',
    AddLogisticsCompany: 'Add Logistics Company',
    EditLogisticsCompany: 'Edit Logistics Company',
    LogisticsCompanyCanNotBeEmpty: 'Logistics Company Can Not Be Empty',
    LinkManCanNotBeEmpty: 'Link Man Can Not Be Empty',
    AddressCanNotBeEmpty: 'Address Can Not Be Empty',
    WebsiteCanNotBeEmpty: 'Website Can Not Be Empty',
    TelCanNotBeEmpty: 'Tel Can Not Be Empty',
    PleaseEnterCorrectWebsite: 'Please Enter Correct Website',
    PleaseEnterCorrectTel: 'Please Enter Correct Tel'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/logisticscompany.js